import { http, HttpResponse, passthrough } from "msw";

import * as gridboxMocks from "@/mocks/products";
import * as recoMocks from "@/mocks/recomendation";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getGridboxResponse = (query: any) => {
  const erpNumbersParam: string | string[] = query.erpNumbers;
  if (!erpNumbersParam) return null;

  const erpNumbers = Array.isArray(erpNumbersParam) ? erpNumbersParam : erpNumbersParam.split(",");

  if (erpNumbers[0] === gridboxMocks.rdpProductGridboxResponse.erpNumber) {
    return [gridboxMocks.rdpProductGridboxResponse];
  } else if (gridboxMocks.productsGridboxResponse.some((p) => p.erpNumber === erpNumbers[0])) {
    return gridboxMocks.productsGridboxResponse;
  } else if (gridboxMocks.crossGridboxResponse.some((p) => p.erpNumber === erpNumbers[0])) {
    return gridboxMocks.crossGridboxResponse;
  } else if (gridboxMocks.categoryGridboxResponse.some((p) => p.erpNumber === erpNumbers[0])) {
    return gridboxMocks.categoryGridboxResponse;
  } else if (gridboxMocks.brandGridboxResponse.some((p) => p.erpNumber === erpNumbers[0])) {
    return gridboxMocks.brandGridboxResponse;
  }
};

export const handlers = [
  http.get("https://recommendations-dev.lidl-shop.com/r/api/recommendations/:country/:lang/web/:type/:id", () => {
    return HttpResponse.json(recoMocks.productsResponse);
  }),
  http.get("*/p/api/gridboxes/:country/:lang", async ({ request }) => {
    const url = new URL(request.url);
    const query = Object.fromEntries(url.searchParams.entries());
    return HttpResponse.json(getGridboxResponse(query));
  }),
  http.get("*/r/api/recommendations/:country/:lang/web/:scenario/:id?", async ({ request }) => {
    const url = new URL(request.url);
    const searchParams = url.searchParams;

    if (url.pathname.includes("cross")) {
      return HttpResponse.json(recoMocks.crossResponse);
    }

    if (searchParams.has("categoryViewedProducts")) {
      return HttpResponse.json(recoMocks.categoryViewedProductsResponse);
    }

    if (searchParams.has("brandViewedProducts")) {
      return HttpResponse.json(recoMocks.brandViewedProductsResponse);
    }

    return HttpResponse.json(recoMocks.productsResponse);
  }),
  http.get("/cdn/*", async ({ request }) => {
    const url = new URL(request.url);
    const assetPath = url.pathname;

    if (process.env.NODE_ENV !== "development" && !url.hostname.includes("localhost")) {
      const redirectUrl = `${url.origin}/storybook${assetPath}`;
      return Response.redirect(redirectUrl, 302);
    }

    return passthrough();
  }),
  http.get("/p/fragment/*", async ({ request }) => {
    const url = new URL(request.url);
    const assetPath = url.pathname;

    if (process.env.NODE_ENV !== "development" && !url.hostname.includes("localhost")) {
      const redirectUrl = `${url.origin}/storybook${assetPath}`;
      return HttpResponse.redirect(redirectUrl, 302);
    }

    return passthrough();
  }),
];
